import { createSelector } from "reselect";
import { ProjectMembersState } from "./types";

const getAllProjectMembers = (state: ProjectMembersState) => state.projectMembers;

export const getProjectMembers = createSelector(
    getAllProjectMembers,
    (state: ProjectMembersState, projectId: number) => projectId,
    (projectMembers, projectId) => projectMembers?.[projectId]
);

export const getProjectUserMembers = createSelector(getProjectMembers, projectMembers =>
    projectMembers?.map(member => member.UserID)?.filter(x => !!x)
);
